import React from 'react';

import { useLocalization } from 'redux/localization/utils/hooks';

const Previous = (props) => {
  const { currentPage, onChange } = props;
  const { t } = useLocalization();

  const handleOnClick = () => {
    onChange(getPageNumber(currentPage));
  };

  const isDisabled = currentPage < 2;

  return (
    <li className="c7-pagination__arrow">
      <button
        className="c7-link"
        type="button"
        disabled={isDisabled}
        onClick={handleOnClick}
      >
        <span className="c7-sr-only">
          {t('general.accessibility.previousPage')}
        </span>
        <svg
          aria-hidden="true"
          focusable="false"
          role="presentation"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
    </li>
  );
};

const getPageNumber = (currentPage) => {
  // Ensure we cant go to page=0
  if (currentPage > 1) {
    return currentPage - 1;
  }

  return 1;
};

export default Previous;
